import { Button, Card, Col, Flex, Modal, Row, Space } from "antd";
import TableAntd from "components/elements/Table";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import dayjs from "dayjs";
import { ReactComponent as YesIcon } from "../../../assets/icon/yesCircle.svg";
import { ReactComponent as NoIcon } from "../../../assets/icon/noCircle.svg";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useState } from "react";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";

const ApproveTeamTimesheetModal = ({
    open = false,
    timesheetDetailsByEmp = [],
    selectedRecord = null,
    onTimesheetDetailsPageChange = () => { },
    isLoading = false,
    pagination = {},
    setIsModalOpen = () => { },
    onApproveTimesheetByList = () => { },
    onRejectTimesheetByList = () => { },
    useFilterDetail = false,
    setUseFilterDetail = () => { },
    taskOptions = [],
    handleSearchDetailModal = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const hasSelected = selectedRowKeys.length > 0;

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: record?.approveStatusCode?.toLowerCase() === "approved" || record?.approveStatusCode?.toLowerCase() === "reject"
        }),
    };


    const columns = [
        {
            title: <div className="text-table" >{t("my_timesheet.label.request_date")}</div>,
            dataIndex: "dateOfRequest",
            key: "dateOfRequest",
            width: 120,
            render: (_, record) => (
                dayjs(record?.submitDate).format(i18n.language == "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")
            )
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.dateTimeRecord")}</div>,
            dataIndex: "startDate",
            key: "startDate",
            width: 120,
            render: (_, record) => (
                dayjs(record?.startDate).format(i18n.language == "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")
            )
        },
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t("my_timesheet.label.roles")}</div>,
            dataIndex: "roleName",
            key: "roleName",
            render: (_, record) => {
                return (
                    <span>{record?.role?.roleName}</span>
                )
            }
        },
        {
            title: <div className="text-table" style={{ textAlign: "center" }} >{t("my_timesheet.label.task")}</div>,
            dataIndex: "taskName",
            key: "taskName",
            render: (_, record) => {
                return (
                    <span>{i18n.language === "en" ? record?.task?.taskNameEn : record?.task?.taskName}</span>
                )
            }
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.number_of_working_hour")}</div>,
            dataIndex: "totalWorkingHours",
            key: "totalWorkingHours",
            align: "center",
            render: (_, record) => (
                `${record?.totalWorkingHours ?? "0"} ${t("unit.hours")} ${record?.totalWorkingMinutes ?? "0"} ${t("unit.minute_0")}`
            )
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.details")}</div>,
            dataIndex: "description",
            key: "description",
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.billable")}</div>,
            dataIndex: "billableFlag",
            key: "billableFlag",
            align: "center",
            width: 100,
            render: (_, record) => {
                if (record?.billableFlag === "Y") {
                    return <YesIcon />;
                } else if (record?.billableFlag === "N") {
                    return <NoIcon />;
                } else {
                    return null;
                }
            }
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.status")}</div>,
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (_, record) => {
                return (
                    <StatusTag
                        value={i18n.language == "en" ? record?.approveStatusEn : record?.approveStatus}
                        text={i18n.language == "en" ? record?.approveStatusEn : record?.approveStatus}
                    />
                )
            }
        },
    ]

    return (
        <Modal
            open={open}
            title={
                <span style={{ color: "#667085" }}>
                    {t("my_timesheet.label.more_details")}
                </span>
            }
            footer={null}
            closable={false}
            maskClosable={false}
            width={"75vw"}
            destroyOnClose
        >
            <Space size={16} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <Flex gap={8}>
                        <span style={{ color: "#667085" }}>{`${t("employee.label.name")} :`}</span>
                        <span style={{ color: "#667085", fontWeight: "bold" }}>{i18n.language === "en" ? selectedRecord?.fullNameEn : selectedRecord?.fullName}</span>
                    </Flex>
                    <Flex gap={8}>
                        <span style={{ color: "#667085" }}>{`${t("my_timesheet.label.project")} :`}</span>
                        <span style={{ color: "#667085", fontWeight: "bold" }}>{i18n.language === "en" ? selectedRecord?.projectNameEn : selectedRecord?.projectName}</span>
                    </Flex>
                </Flex>

                <Row justify={"end"} style={{ gap: "8px" }}>
                    <Button type="default"
                        style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", color: "#667085" }}
                        icon={<FilterIcon style={{ fontSize: 16 }} />}
                        onClick={() => setUseFilterDetail(!useFilterDetail)}
                    >
                        {t("common.filter")}
                    </Button>
                </Row>

                {useFilterDetail && (
                    <Card
                        style={{
                            borderRadius: "8px",
                            backgroundColor: "white",
                            border: "1px solid #EAECF0",
                            width: "100%",
                        }}
                    >
                        <FormAntd
                            onFinish={handleSearchDetailModal}
                        >
                            <FormItem shouldUpdate={(prev, curv) => {
                                return false
                            }}>
                                {({ resetFields }) => {
                                    return (
                                        <Space direction="vertical" size={24} style={{ width: "100%" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="startToEndDate"
                                                        type="range"
                                                        label={t('start-date-to-end-date')}
                                                        placeholder={[t('common.please_select_start_date'), t('holiday.label.end_date')]}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="taskId"
                                                        label={t("my_timesheet.label.task")}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        options={taskOptions}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="approveStatus"
                                                        label={t("my_timesheet.label.request_status")}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        options={[
                                                            { value: 'Draft', label: t("approve-status.draft") },
                                                            { value: 'Pending', label: t("approve-status.pending") },
                                                            { value: 'Approved', label: t("approve-status.approve") },
                                                            { value: 'Rejected', label: t("approve-status.reject") },
                                                        ]}
                                                        allowClear
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                <Button
                                                    type="default"
                                                    onClick={() => { resetFields() }}
                                                    style={{ borderRadius: "8px" }} size="large"
                                                >
                                                    {t("common.cancel").toUpperCase()}
                                                </Button>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                                    size="large"
                                                >
                                                    {t("common.search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Space>
                                    )
                                }}
                            </FormItem>
                        </FormAntd>
                    </Card>
                )}

                <TableAntd
                    columns={columns}
                    dataSource={timesheetDetailsByEmp}
                    onChange={onTimesheetDetailsPageChange}
                    loading={isLoading}
                    pagination={{
                        ...pagination,
                    }}
                    rowSelection={rowSelection}
                    rowKey={(record) => record?.id}
                />

                <Flex vertical gap={8} style={{ alignItems: "end" }}>
                    {hasSelected &&
                        <span>{`${t("common.selected")} ${selectedRowKeys?.length} ${t("my_timesheet.label.items")}`}</span>}
                    <Row style={{ gap: "8px" }}>
                        <Button
                            type="default"
                            style={{ borderRadius: "8px", height: "40px" }}
                            onClick={() => {
                                setSelectedRowKeys([]);
                                setIsModalOpen(false);
                            }}
                        >
                            {t("my_timesheet.label.cancel")}
                        </Button>
                        {hasSelected &&
                            (
                                <>
                                    <Button
                                        type="default"
                                        style={{ borderRadius: "8px", height: "40px" }}
                                        onClick={() => {
                                            const selectedRecords = timesheetDetailsByEmp.filter(item =>
                                                selectedRowKeys.includes(item?.id)
                                            );

                                            let listModel = {}
                                            selectedRecords.forEach((item) => {
                                                let model = listModel[item.myTimeSheetApproveId]
                                                if (model) {
                                                    listModel[item.myTimeSheetApproveId] = [...listModel[item.myTimeSheetApproveId], item.id]
                                                } else {
                                                    listModel[item.myTimeSheetApproveId] = [item.id]
                                                }
                                            });

                                            let pod = Object.entries(listModel).map((c) => {

                                                return {
                                                    myTimeSheetApproveId: c[0],
                                                    myTimeSheetListId: c[1]
                                                }
                                            })

                                            onRejectTimesheetByList(pod).then(() => {
                                                setSelectedRowKeys([]);
                                            });
                                        }}
                                    >
                                        {t("request_approval.label.not_approved")}</Button>
                                    <Button
                                        type="primary"
                                        style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
                                        onClick={() => {
                                            const selectedRecords = timesheetDetailsByEmp.filter(item =>
                                                selectedRowKeys.includes(item?.id)
                                            );

                                            let listModel = {}
                                            selectedRecords.forEach((item) => {
                                                let model = listModel[item.myTimeSheetApproveId]
                                                if (model) {
                                                    listModel[item.myTimeSheetApproveId] = [...listModel[item.myTimeSheetApproveId], item.id]
                                                } else {
                                                    listModel[item.myTimeSheetApproveId] = [item.id]
                                                }
                                            });

                                            let pod = Object.entries(listModel).map((c) => {

                                                return {
                                                    myTimeSheetApproveId: c[0],
                                                    myTimeSheetListId: c[1]
                                                }
                                            })

                                            onApproveTimesheetByList(pod).then(() => {
                                                setSelectedRowKeys([]);
                                            });
                                        }}
                                    >{t("request_approval.label.approve")}</Button>
                                </>)}
                    </Row>
                </Flex>
            </Space>
        </Modal>
    )
}

export default ApproveTeamTimesheetModal;